import { CerFormAdapter } from '@form/cer-form-adapter';
import { CerFormViewSet } from '@form/cer-form-view-set';
import { CerFormView } from '@form/cer-form-view';
import { FieldWidthEnum } from '@data/cer-data-types';
import { RoyaltyHistoryForm } from './royalty-history.form';

export class RoyaltyStatusForm extends CerFormAdapter {

    override viewSetInit(viewSet: CerFormViewSet): void {
        const navProject = this.routeOptions.navigation?.columnNameChild == 'projectNum';
        const view = RoyaltyStatusForm.viewGet(navProject);
        viewSet.viewAdd(view);
    }

    public static viewGet(navProject: boolean): CerFormView {
        const view = new CerFormView();
        view.viewMetadata = {
            name: 'royalty-status', dataApiName: 'RoyaltyAfregningTransAktuelView',
            primaryKey: 'id', baseFields: ['id'],
            allowCreate: false, allowEdit: false, allowDelete: false,
            navigations: [
                { link: 'navMenu', linkMenu: 'Kontrakt', title: 'Royalty, godkendelse', paneTarget: 'bottom', foreignKey: { parentEntity: 'RoyaltyAfregningAktuelView', parentColumn: 'hovedkontrakt', column: 'hovedkontrakt' } },
                { link: 'navMenu', linkMenu: 'Kontrakt', title: 'Royalty, historik', paneTarget: 'bottom', foreignKey: { parentEntity: 'RoyaltyAfregningTransHistorikView', parentColumn: 'hovedkontrakt', column: 'hovedkontrakt' } }
            ]
        };

        view.fieldMetadata =
            [
                { name: 'hovedKontrakt', text: 'Kontrakt' },
                {
                    name: 'fid', text: 'Forlag/Agent', widthType: FieldWidthEnum.XXXXL, orderBy: 'Ascending', orderByPriority: 1,
                    foreignKeyTableName: 'Forfatter', foreignKeyField: 'id', foreignKeyValue: 'idNavn'
                },
                { name: 'dato', text: 'Dato', format: 'DateShort', orderBy: 'Ascending', orderByPriority: 3 },
                { name: 'sort', text: 'Sortering', format: 'Integer', visible: false, orderBy: 'Ascending', orderByPriority: 21},
                { name: 'isbn', text: 'ISBN', foreignKeyType: 'product'},
                { name: 'title', text: 'Titel' },
                { name: 'edition', text: 'Udgave' },
                { name: 'udgivelsesDato', text: 'Udg.dato', format: 'DateShort' },
                { name: 'omsAntal', text: 'Antal solgt', format: 'Integer', widthType: FieldWidthEnum.S, footerType: 'Sum' },
                { name: 'omsBelobVal', text: 'Omsætning', format: 'Amount0', widthType: FieldWidthEnum.S },
                { name: 'royaltyBelobBeregnVal', text: 'Royalty', format: 'Amount0', widthType: FieldWidthEnum.S },
            ];

        return view;
    }
}